<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Deadly Identity &amp; Deadly Silence</title>
<link href="../styles/HQ_CSS.css" rel="stylesheet" type="text/css"/>
<section>
<h2 class="conhead"><i>Table of Contents</i></h2>
<p class="toc"><a href="#/text/Cover_1"><i>Deadly Identity</i><br/> By Lindsay McKenna</a></p>
<p class="toc"><span href="#/text/Cover_2" title="Link target outside of Sample"><i>Deadly Silence</i><br/> By Lindsay McKenna</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?951548e2